import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { isGuestUser } from "@thalamos/aspire-common";

import { LoggedInUserContext } from "../../Contexts.js";
import { routeFns } from "../../routePaths.js";
import { Button, ButtonIcon } from "~/components/design-system/index.js";

export function OpenPatientEditDialog({
  canGuestUserEdit,
}: {
  canGuestUserEdit?: boolean;
}) {
  const { formDraftId, patientId } = useParams();
  const navigate = useNavigate();

  const userContext = useContext(LoggedInUserContext);
  const user = userContext?.user!;

  const isCurrentUserGuestUser = isGuestUser(user);

  return (
    <>
      {(!isCurrentUserGuestUser || canGuestUserEdit) && (
        <Button
          sx={{ mt: 1 }}
          customFontSize={2}
          label="Edit patient information"
          color="primary"
          variant="outlined"
          startIcon={ButtonIcon.create}
          onClick={() =>
            navigate(routeFns.patientEditDialog(formDraftId!, patientId!))
          }
        />
      )}
    </>
  );
}
